"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVerpackung18 = exports.verpackung18UseableDef = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ArticleBase_1 = require("../../ArticleBase");
exports.verpackung18UseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.verpackung,
    },
};
exports.isVerpackung18 = echain_shared_modelling_1.UseableUtil.createGuard(exports.verpackung18UseableDef);
//# sourceMappingURL=Verpackung18.js.map